import { recordEvent } from "./api";

export function trackEvent(eventType: string, metadata?: Record<string, unknown>) {
  const enrichedMetadata =
    typeof window === "undefined"
      ? metadata
      : {
          ...metadata,
          path: window.location.pathname,
          referrerHost: referrerHost(document.referrer),
        };
  // Fire-and-forget; analytics must never block the UI.
  recordEvent(eventType, enrichedMetadata).catch(() => {
    // Silently ignore analytics failures.
  });
}

function referrerHost(referrer: string): string | undefined {
  if (!referrer) return undefined;
  try {
    const url = new URL(referrer);
    return url.host === window.location.host ? undefined : url.host;
  } catch {
    return undefined;
  }
}
